/* eslint-disable @typescript-eslint/no-explicit-any */
import { Directive, HostBinding, HostListener, Input, OnChanges } from '@angular/core';
import { BugsnagService } from '@mode/shared/util-error-handling';

@Directive({
  selector: '[modeIntercom]',
})
export class IntercomDirective implements OnChanges {
  @Input() href: string | undefined;
  @Input() intercomEmail: string | undefined;
  @Input() intercomMessage: string | undefined;
  @Input() disableOnShow = false;
  public disabled = false;

  @HostBinding('class.disabled')
  public get isDisabled(): boolean {
    return this.disabled;
  }

  constructor(private bugsnag: BugsnagService) {}

  public ngOnChanges() {
    if (!this.intercomEmail && !this.href) {
      console.warn('Intercom fallback not provided');
    }
  }

  @HostListener('click', ['$event'])
  public onClick(event: MouseEvent): void {
    const IntercomClient: any = (window as { [k: string]: any })['Intercom'] as any;
    if (typeof IntercomClient === 'undefined' || !IntercomClient.booted) {
      const intercomStatus = typeof IntercomClient === 'undefined' ? 'undefined' : 'uninitialized';
      this._logFailure(intercomStatus);

      if (!this.intercomEmail && this.href && !this._isMailToLink(this.href)) {
        window.open(this.href, '_blank');
        event.preventDefault();
        return;
      }
      // force page to given email unless mailto link is on element
      if (!this._isMailToLink(this.href)) {
        event.preventDefault();
        // If fallback email wasn't provided, default to help
        location.assign(`mailto:${this.intercomEmail || 'help@modeanalytics.com'}?subject=${this.intercomMessage}`);
      }
    } else {
      event.preventDefault();

      if (this.intercomMessage) {
        IntercomClient('showNewMessage', this.intercomMessage);
      } else {
        IntercomClient('show');
      }

      if (this.disableOnShow) {
        IntercomClient('onShow', () => (this.disabled = true));
        IntercomClient('onHide', () => (this.disabled = false));
      }
    }
  }

  private _isMailToLink(href: string | undefined): boolean {
    if (!href || typeof href !== 'string') {
      return false;
    }
    return href.indexOf('mailto:') === 0;
  }

  private _logFailure(intercomStatus: string): void {
    const error = new Error(`Intercom widget failed on ${intercomStatus}`);
    console.error(error.message);
    this.bugsnag.notify(error);
  }
}
